import { createAsyncActionType } from './types';

export const LOGIN_ON_FERRARI = createAsyncActionType('LOGIN', 'LOGIN_ON_FERRARI');
export const ACCESS_TOKEN = createAsyncActionType('LOGIN', 'ACCESS_TOKEN');
export const CONVERT_TOKEN = createAsyncActionType('LOGIN', 'CONVERT_TOKEN');
export const PARSE_JWT_TOKEN = createAsyncActionType('LOGIN', 'PARSE_JWT_TOKEN');
export const REFRESH_TOKEN = createAsyncActionType('LOGIN', 'REFRESH_TOKEN');
